import React from 'react'
import LegacyLink from 'components/LegacyLink'
import { Flex, Box, BoxHeadline, Button, SUI } from 'shared/ui'

const NotFound = ({ className, text, linkText, to }) => {
  return (
    <Flex
      className={className}
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      mt={6}
      mr={3}
      mb={6}
      ml={3}
    >
      <Box>
        <BoxHeadline>{text}</BoxHeadline>
      </Box>
      <Box mt={2}>
        <SUI>
          <Button
            size="medium"
            primary
            path={to}
            as={LegacyLink}
            target="_blank"
          >
            {linkText}
          </Button>
        </SUI>
      </Box>
    </Flex>
  )
}

export default NotFound
